import React, {Component} from 'react';
import {Link} from 'react-router-dom';

const shopnowIconStyle = {
  width: '200px',
  height: '40px',
  display: "inline-block",

  backgroundColor: '#63CA47',
  borderRadius: '37.5px',
  fontFamily: 'Arial',
  fontSize: '20px',
  lineHeight: '40px',
  color: '#EEE',
  textAlign: 'center'
}

class ShopnowIcon extends Component {
  render() {
    return(
      <Link to="/category/all">
        <div className="ShopnowIcon" style={shopnowIconStyle}>
         Shop Now
        </div>
      </Link>
    );
  }
}

export default ShopnowIcon;



// WEBPACK FOOTER //
// ./src/components/homepage/shopnowIcon.js